import Dialog, { DialogProps } from './Dialog';

export type { DialogProps };
export default Dialog;
